import CreativeInsights from "./CreativeInsights";

export default CreativeInsights;
